/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A flexible date range. To be used when searching for a stay of a particular number of nights within a set of dates
 * @export
 * @interface FlexibleDateRange
 */
export interface FlexibleDateRange {
    /**
     * 
     * @type {Date}
     * @memberof FlexibleDateRange
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof FlexibleDateRange
     */
    endDate: Date;
    /**
     * Start date in string format, e.g. 2023-10-01
     * @type {string}
     * @memberof FlexibleDateRange
     */
    startDateStr?: string;
    /**
     * End date in string format, e.g. 2023-10-02
     * @type {string}
     * @memberof FlexibleDateRange
     */
    endDateStr?: string;
    /**
     * 
     * @type {number}
     * @memberof FlexibleDateRange
     */
    nights: number;
}

/**
 * Check if a given object implements the FlexibleDateRange interface.
 */
export function instanceOfFlexibleDateRange(value: object): value is FlexibleDateRange {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('nights' in value) || value['nights'] === undefined) return false;
    return true;
}

export function FlexibleDateRangeFromJSON(json: any): FlexibleDateRange {
    return FlexibleDateRangeFromJSONTyped(json, false);
}

export function FlexibleDateRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlexibleDateRange {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
        'startDateStr': json['start_date_str'] == null ? undefined : json['start_date_str'],
        'endDateStr': json['end_date_str'] == null ? undefined : json['end_date_str'],
        'nights': json['nights'],
    };
}

export function FlexibleDateRangeToJSON(json: any): FlexibleDateRange {
    return FlexibleDateRangeToJSONTyped(json, false);
}

export function FlexibleDateRangeToJSONTyped(value?: FlexibleDateRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start_date': value['startDate'].toISOString().substring(0,10),
        'end_date': value['endDate'].toISOString().substring(0,10),
        'start_date_str': value['startDateStr'],
        'end_date_str': value['endDateStr'],
        'nights': value['nights'],
    };
}

